import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/password_ic_tip@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-3aeb037c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "password_tip" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", null, "绑定手机号可以更好地保护您的账户安全，保护个人信息不被侵害。")
], -1))
const _hoisted_3 = { class: "password_list" }
const _hoisted_4 = { class: "password_list_item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前绑定", -1))
const _hoisted_6 = { class: "password_list_item_box" }
const _hoisted_7 = { class: "password_list_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新手机号", -1))
const _hoisted_9 = { class: "password_list_item_box" }
const _hoisted_10 = { class: "password_list_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "验证码", -1))
const _hoisted_12 = { class: "password_list_item_box" }
const _hoisted_13 = { class: "password_footer" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "完成", -1))
const _hoisted_15 = [
  _hoisted_14
]

import { reactive, onBeforeUnmount } from 'vue'
    import { Toast } from 'vant'
    import { useStore } from "vuex"
    import { useRouter } from "vue-router"
    import { REGULAR } from '@/utils/utils'
    import { updatePhoneVerification } from '@/interface'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter()

    const store = useStore()

    // 表单相关
    let form = reactive<updatePhoneVerification>({
        currentPhone: store.state.userInfo.companyUser.phone,
        newPhone: '',
        verificationCode: ''
    })

    // 验证码相关
    let code = reactive<{ num: number, isOpen: boolean, timer: number }>({
        num: 60,
        isOpen: false,
        timer: 0
    })

    // 获取验证码
    const getVerificationCode = (): void => {
        code.isOpen = true
        code.timer = setInterval(() => {
            if (code.num === 0) {
                clearInterval(code.timer)
                code.isOpen = false
                code.num = 60
            }
            code.num = code.num - 1
        }, 1000)
    }

    const submit = (): void => {
        if (!form.newPhone) {
            Toast({ message: '新手机号不能为空' })
        } else if (!REGULAR.phoneRegular.test(form.newPhone)) {
            Toast({ message: '手机号不合法' })
        } else if (!form.verificationCode) {
            Toast({ message: '验证码不能为空' })
        } else {
            console.log('可以提交')
        }
    }

    onBeforeUnmount(() => {
        clearInterval(code.timer)
    })

return (_ctx: any,_cache: any) => {
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            disabled: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).currentPhone) = $event)),
            maxlength: "11"
          }, null, 512), [
            [_vModelText, _unref(form).currentPhone]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).newPhone) = $event)),
            maxlength: "11",
            placeholder: "请输入新手机号"
          }, null, 512), [
            [_vModelText, _unref(form).newPhone]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).verificationCode) = $event)),
            maxlength: "4",
            placeholder: "请输入手机验证码"
          }, null, 512), [
            [_vModelText, _unref(form).verificationCode]
          ]),
          (!_unref(code).isOpen)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                onClick: getVerificationCode
              }, "获取验证码"))
            : (_openBlock(), _createElementBlock("p", {
                key: 1,
                onClick: getVerificationCode
              }, _toDisplayString(_unref(code).num), 1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "password_footer_submit",
        onClick: submit
      }, _hoisted_15)), [
        [_directive_preventReClick]
      ])
    ])
  ]))
}
}

})